import styled from 'styled-components';

export const Spacing = styled.div<{ $val: string }>`
  padding: ${({ $val }) => $val};
`;
